module.exports = __webpack_public_path__ + "img/full0-min.f7468298.png";